import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useCustomHotkeys } from '../../../../common/hooks/useCustomHotkeys';
import { IFreeAccessNavigationProps } from '../containers/freeAccessNavigation.container';

export const FreeAccessImageNavigation = observer((props: IFreeAccessNavigationProps): ReactElement => {
  const { t } = useTranslator();

  useCustomHotkeys(
    'left',
    () => {
      props.goTo(props.previousLink);
    },
    { enabled: props.current > 1 && !props.isLoading, keydown: false, keyup: true },
    [props.goTo]
  );
  useCustomHotkeys(
    'right',
    () => {
      props.goTo(props.nextLink);
    },
    { enabled: props.current < props.total && !props.isLoading, keydown: false, keyup: true },
    [props.goTo]
  );

  return (
    <div className='image-navigation'>
      <Button
        tabIndex={-1}
        startDecorator={<FontAwesomeIcon icon='angle-left' />}
        onClick={(): void => {
          props.goTo(props.previousLink);
        }}
        color='neutral'
        variant='transparent'
        disabled={props.current <= 1 || props.isLoading}
      >
        {t('previous')}
      </Button>
      <span className='images-count'>
        {props.current} {t('of')} {props.total}
      </span>
      <Button
        tabIndex={-1}
        onClick={(): void => {
          props.goTo(props.nextLink);
        }}
        endDecorator={<FontAwesomeIcon icon='angle-right' />}
        color='neutral'
        variant='transparent'
        disabled={props.current >= props.total || props.isLoading}
      >
        {t('next')}
      </Button>
    </div>
  );
});
